/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plan_Tab_Billed_SeatsInputs */



/**
* | output |
* | --- |
* | "billed for {count} seats" |
*
* @param {Plan_Tab_Billed_SeatsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const plan_tab_billed_seats = /** @type {((inputs: Plan_Tab_Billed_SeatsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Tab_Billed_SeatsInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Abrechnung für ${i?.count} Plätze`)
	return /** @type {LocalizedString} */ (`billed for ${i?.count} seats`)
});